import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CounterComponent),
      multi: true,
    }
  ],
  standalone: true,
  imports: [MatButtonModule, MatIconModule]
})
export class CounterComponent implements OnInit, ControlValueAccessor {
  constructor(private cdr: ChangeDetectorRef) {}

  public viewValue: number = 0;

  @Input() isDisabled: boolean = false;
  @Input() max: number = Infinity;
  @Input() min: number = 0;
  @Input() isLockAdd: boolean = false;

  @Output() changeValue: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit(): void {
    if (this.max == 0) {
      this.max = Infinity;
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;

    setTimeout(() => {
      this.onChange(this.viewValue);
    }, 10);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if (obj) {
      this.viewValue = obj;
      this.cdr.detectChanges();
    }
  }

  onAdd(): void {
    if(this.isDisabled || this.isLockAdd) {return}
    if(this.viewValue >= this.max) {return}

    this.viewValue++;

    this.onChange(this.viewValue);
    this.changeValue.emit(this.viewValue);
  }

  onRemove(): void {
    if(this.isDisabled) {return}

    if(this.viewValue <= this.min) {return}
    this.viewValue--;

    this.onChange(this.viewValue);
    this.changeValue.emit(this.viewValue);
  }
}
